/**
 * W2.5: URL "Mở trên 7wportal" của dự án — thay `{id}` bằng id đã `encodeURIComponent`. Chỉ nhận `http(s):`; mẫu
 * sai/thiếu `{id}` → undefined (không hiện nút) thay vì mở một trang lạ.
 */
export function buildPortalProjectUrl(projectId: string, template: string): string | undefined {
  if (!template.includes('{id}')) return undefined;
  try {
    const url = new URL(template.replaceAll('{id}', encodeURIComponent(projectId)));
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : undefined;
  } catch {
    return undefined;
  }
}
